import { createSelector } from '@ngrx/store'

export const getTemplatesState = createSelector(
  (state: any) => state.templates,
  (state: any) => state.get('list'),
)

export const getTemplateTagsState = createSelector(
  (state: any) => state.templates,
  (state: any) => state.get('tags'),
)

export const getCreateTemplateState = createSelector(
  (state: any) => state.templates,
  (state: any) => state.get('createTemplate'),
)

export const getUpdateTemplateState = createSelector(
  (state: any) => state.templates,
  (state: any) => state.get('updateTemplate'),
)

export const getTestTemplateState = createSelector(
  (state: any) => state.templates,
  (state: any) => state.get('testTemplate'),
)
